import React, { Component } from 'react';
import PropTypes from 'prop-types';
import whiteBackground from '../wrapper-components/white-background';
import AttendeeAddDetailsPageBody from './AttendeeAddDetailsPageBody';
import _ from 'lodash';
import { push } from 'react-router-redux';
import { connect } from 'react-redux';
import { injectIntl } from 'react-intl';

class AttendeeAddDetailsPageMain extends Component {
  constructor (props) {
    super(props);

    this.redirectToSendInvite = this.redirectToSendInvite.bind(this);
    this.redirectToInbox = this.redirectToInbox.bind(this);
  }

  redirectToSendInvite () {
    const bookingId = _.get(this.props, 'booking.booking._id');
    this.props.dispatch(push(`/invite/send/${bookingId}`));
  }

  redirectToInbox () {
    const bookingId = _.get(this.props, 'booking.booking._id');
    this.props.dispatch(push(`/inbox/${bookingId}`));
  }

  render () {
    return (
      <div className="AttendeeAddDetailsPageMain">
        <div className="content-container">
          <AttendeeAddDetailsPageBody
            {...this.props}
            pageType="add_details_booking"
            submitRedirect={this.redirectToSendInvite}
            cancelRedirect={this.redirectToInbox}
            showSkip={true}
            submitButtonText={this.props.intl.formatMessage({ id: 'invite.attendee_add_details_page_main.save_continue', defaultMessage: 'Save and Continue' })}
          />
        </div>
      </div>
    );
  }
}

AttendeeAddDetailsPageMain.propTypes = {
  dispatch: PropTypes.func
};

const mapStateToProps = ({ booking }) => ({ booking });

export default injectIntl(connect(mapStateToProps)(whiteBackground(AttendeeAddDetailsPageMain)));
